import s from './PasswordRequirementsList.module.scss';
import classNames from 'classnames';
import { FieldError } from 'react-hook-form';
import Check from '@/shared/assets/icons/check.svg';
import Close from '@/shared/assets/icons/close.svg';
import Dot from '@/shared/assets/icons/dot.svg';

interface PasswordRequirementsListProps {
  error?: FieldError;
  isTouched?: boolean;
  value?: string;
  className?: string;
}

const listData = [
  {
    type: 'count',
    title: 'Минимум 8 символов',
    checkMet: (val: string, error?: FieldError) =>
      val.length >= 8 && val.length <= 64 && !error?.types?.min && !error?.types?.max,
  },
  {
    type: 'words',
    title: 'Есть заглавные и строчные буквы',
    checkMet: (val: string, error?: FieldError) => /(?=.*[a-z])(?=.*[A-Z])/.test(val) && !error?.types?.words,
  },
  {
    type: 'special',
    title: 'Есть спецсимвол (например: ! @ # $ %)',
    checkMet: (val: string, error?: FieldError) =>
      /(?=.*[~!?@#$%^&*_\-+()[\]{}></\\|"'.,:])/.test(val) && !error?.types?.special,
  },
  {
    type: 'digit',
    title: 'Есть цифра',
    checkMet: (val: string, error?: FieldError) => /\d/.test(val) && !error?.types?.digit,
  },
];

export const PasswordRequirementsList = (props: PasswordRequirementsListProps) => {
  const { error, isTouched, value = '', className } = props;
  const hasValue = value.length > 0;
  const isActive = isTouched || hasValue;

  return (
    <div className={classNames(s.info, {}, [className])}>
      <ul className={s.list}>
        {listData.map(({ type, title, checkMet }) => {
          const isInitial = !hasValue && !isTouched;
          const isMet = hasValue ? checkMet(value, error) : false;
          const hasError = isActive && !isMet;

          return (
            <li
              key={type}
              className={classNames(s.listItem, {
                [s.initial]: isInitial,
                [s.error]: hasError,
                [s.valid]: !isInitial && isMet,
              })}
            >
              {isInitial && <Dot className={s.icon} />}
              {hasError && <Close className={s.icon} />}
              {!isInitial && isMet && <Check className={s.icon} />}
              {title}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
